module.exports = __webpack_public_path__ + "img/57.958331c9.svg";